import { Field, reduxForm } from "redux-form";
import i18n from "@local/i18next/i18n";
import { isRequired, isRequiredAndNotEmptyString, isValidEmail } from "@local/utils/validators";
import FieldText from "@local/components/field-text";
const EmailForm = () => {
  return <Field label={i18n.t("E-mail")} validate={[isRequired, isValidEmail, isRequiredAndNotEmptyString]} component={FieldText} id="emailForCheck" name="emailForCheck" />;
};

export default reduxForm({ form: "emailCheckForm", enableReinitialize: true, destroyOnUnmount: false })(EmailForm);
